module.exports = __webpack_public_path__ + "assets/img/contact.dac700a2.svg";